import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {
  img: string;
  constructor(private router: Router) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".intro-overview").addClass("header_active")


    if (window.location.href.indexOf("/fr/") > -1) {
      this.img="./assets/img/Components_FR.png";}
  else if (window.location.href.indexOf("/es/") > -1){
    this.img="./assets/img/Components_SP.png";}
    else if (window.location.href.indexOf("/pt/") > -1){
      this.img="./assets/img/Components_PT.png";}

      else if (window.location.href.indexOf("/ko/") > -1){

        this.img="./assets/img/Components_KO.png";}

        else if (window.location.href.indexOf("/ar/") > -1){

          this.img="./assets/img/Component_ar.png";}

  else {
    this.img="./assets/img/polcritcomp.png";}


  }
}



// WEBPACK FOOTER //
// ./src/app/introduction/overview/overview.component.ts